import { getToken } from './api';

/**
 * Trigger a server-side bulk export of selected questions.
 * Submits a hidden <form> POST so the browser's download mechanism kicks in
 * (works for both XLSX/CSV/PDF responses without us having to read a Blob).
 *
 * `format` accepts: 'excel' | 'pdf' | 'csv' | 'json' (server matches v7 contract).
 */
export function exportQuestions(
  questionIds: number[],
  format: 'excel' | 'pdf' | 'csv' | 'json' | 'zip_by_type' = 'excel'
) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/api/questions/export.php';
  form.target = '_blank';
  form.style.display = 'none';

  const append = (name: string, value: string) => {
    const i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    i.value = value;
    form.appendChild(i);
  };

  append('direct', '1');
  append('format', format);
  append('question_ids', JSON.stringify(questionIds));
  // Token in body — export.php supports form-token auth in addition to header
  const token = getToken();
  if (token) append('token', token);

  document.body.appendChild(form);
  form.submit();
  setTimeout(() => form.remove(), 1000);
}

/**
 * Download a single question via the export-single.php endpoint.
 * Format options match v7 contract (PDF / Word / image).
 */
export function downloadSingleQuestion(
  questionId: number,
  format: 'pdf' | 'docx' | 'image' = 'pdf'
) {
  const token = getToken();
  const params = new URLSearchParams({ id: String(questionId), format });
  if (token) params.set('token', token);
  // Open in a new tab so the browser handles the download / preview natively
  window.open(`/api/questions/export-single.php?${params.toString()}`, '_blank');
}
